import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    cancelError:
      'An error occurred while deleting your export. Please try again later or contact support if the problem persists.',
    confirm: 'Confirm',
    description: 'Are you sure you want to delete it?',
    title: 'Your accountant will no longer receive your monthly export',
  },
  fr: {
    cancel: 'Annuler',
    cancelError:
      'Une erreur est survenue lors de la suppression de l’export. Merci de réessayer plus tard ou de contacter le support si le problème persiste.',
    confirm: 'Confirmer',
    description: 'Êtes-vous sûr de vouloir le supprimer\xa0?',
    title: 'Votre comptable ne recevra plus votre export mensuel',
  },
});

export default locales;
